<template>
    <div>
        <div :class="{ list: tableWidth !== 'auto' }" v-if="isshow">
            <div class="container">
                <table class="conditionclass">
                    <tbody>
                        <tr class="th">
                            <td>图片</td>
                            <td>产品名称</td>
                            <td>品牌</td>
                            <td>cas</td>
                            <td>货号</td>
                            <td>规格</td>
                            <td>操作</td>
                        </tr>
                    </tbody>
                    <tbody v-for="(item, index) in productList.list" :key="index">
                        <tr>
                            <td width="15%"><img :src="item.structureImage"/></td>
                            <td width="10%">{{ item.productName }}</td>
                            <td width="10%">{{ item.brandName }}</td>
                            <td width="10%">{{ item.casCode }}</td>
                            <td width="10%">
                                <p v-for="(items, indexs) in item.detailList" :key="indexs">
                                    {{ items.specsNo }}
                                </p>
                            </td>
                            <td width="30%">
                                <p v-for="(items, indexs) in item.detailList" :key="indexs">
                                    {{ items.packingUnit + ',' + items.specsDesc }}
                                </p>
                            </td>
                            <td width="15%">
                                价格和基本信息<i
                                    class="el-icon-plus"
                                    style="cursor: pointer;"
                                    @click="changeCloseStatus(index)"
                                ></i>
                            </td>
                        </tr>
                        <tr
                            v-show="item.closestatus"
                            style="background-color:#bbbbbb;padding-bottom:10px;"
                        >
                            <td colspan="7">
                                <table>
                                    <tr style="background-color: #d3cccc;">
                                        <td>货号</td>
                                        <td>包装单位</td>
                                        <td>描述</td>
                                        <td>库存</td>
                                        <td>价格</td>
                                        <td>购买数量</td>
                                        <td>操作</td>
                                    </tr>
                                    <tr
                                        v-for="(items, indexs) in item.detailList"
                                        :key="indexs"
                                        style="background-color: #d3cccc;"
                                    >
                                        <td width="15%">{{ items.specsNo }}</td>
                                        <td width="15%">{{ items.packingUnit }}</td>
                                        <td width="15%">{{ items.specsDesc }}</td>
                                        <td width="15%">{{ items.deliver }}</td>
                                        <td width="15%">
                                            <div v-if="userInfo">
                                                <div v-if="items.discountMoney != '0.00'">
                                                    <span style="color: #ff9236;">{{
                                                        items.discountMoney
                                                    }}</span>
                                                    <span
                                                        style="color: #999; text-decoration: line-through; font-size: 12px; margin-left: 5px;"
                                                        >{{ items.originalMoneyStr }}</span
                                                    >
                                                </div>
                                                <div v-else>询价</div>
                                            </div>
                                            <div v-else>会员可见</div>
                                        </td>
                                        <td width="15%">
                                            <el-input-number
                                                v-model="items.shopNum"
                                                size="mini"
                                                :min="1"
                                                label="描述文字"
                                                @change="changShopNum(indexs)"
                                            ></el-input-number>
                                        </td>
                                        <td width="10%">
                                            <span
                                                class="add-cart"
                                                v-if="items.discountMoney != '0.00'"
                                                @click="addCart(items)"
                                                >加入购物车</span
                                            >
                                            <router-link
                                                to="/promade"
                                                tag="span"
                                                class="add-cart"
                                                v-else
                                                >定制
                                            </router-link>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div
                    class="table-empty"
                    v-if="
                        !productList ||
                            !productList.list ||
                            (productList.list && productList.list.length === 0)
                    "
                >
                    <i class="el-icon-document-copy"></i>
                    <p>暂无数据</p>
                </div>
            </div>
        </div>

        <div class="card-list" v-else>
            <router-link
                class="card-item"
                v-for="(item, index) in productList.list"
                :key="index"
                :to="'/product-detail/' + item.productId"
            >
                <div class="image">
                    <img :src="item.structureImage" @load="imgLoad" />
                </div>
                <div class="info">
                    <div class="product-name">{{ item.productName }}</div>
                    <div class="product-extra">
                        <p>
                            <span class="label">品牌：</span>
                            <span class="active">{{ item.brandName }}</span>
                        </p>
                        <p>
                            <span class="label">CAS：</span>
                            <span>{{ item.casCode }}</span>
                        </p>
                        <p>
                            <span class="label">分子式：</span>
                            <span>{{ item.molecularFormula }}</span>
                        </p>
                        <p>
                            <span class="label">分子量：</span>
                            <span>{{ item.molecularMass }}</span>
                        </p>
                    </div>
                </div>
            </router-link>
        </div>
        <div
            class="table-empty"
            v-if="
                !productList ||
                    !productList.list ||
                    (productList.list && productList.list.length === 0)
            "
        >
            <i class="el-icon-document-copy"></i>
            <p>暂无数据</p>
        </div>

        <div class="pagination" v-if="productList.count">
            <el-pagination
                background
                layout="prev, pager, next, total"
                :total="productList.count"
                :page-size="pageSize"
                :current-page="productList.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/order';

import { mapActions } from 'vuex';

export default {
    name: 'Condition',
    props: ['productList', 'tableWidth', 'pageSize', 'isshow', 'userInfo'],

    methods: {
        ...mapActions(['setreloadUserState']),
        addCart(item) {
            orderApis.addToCart(item.id, item.shopNum).then(() => {
                this.$message({
                    message: '添加成功',
                    type: 'success',
                });
                this.setreloadUserState(true);
            });
        },
        changeCloseStatus(index) {
            this.$emit('changeCloseStatus', index);
        },
        handleCurrentChange: function(val) {
            this.pageNo = val;
            this.$emit('handleCurrentChange', val);
        },
        addCart: function(item) {
            apis.addToCart(item.id, item.shopNum).then(res => {
                this.$message({
                    message: '添加成功',
                    type: 'success',
                });
                this.setreloadUserState(true);
            });
        },
        changShopNum(index) {
            this.$emit('changShopNum', index);
        },
        imgLoad(self) {
            var _img = self.target;
            var _imgWidth = _img.naturalWidth;
            var _imgHeight = _img.naturalHeight;
            if (_imgHeight > 180 || _imgWidth > 180) {
                if (_imgHeight - _imgWidth >= 0) {
                    _img.height = 180;
                    _img.width = (180 / _imgHeight) * _imgWidth;
                    //$(obj).css("height","161");
                    //$(obj).css("width",161/_imgHeight*_imgWidth);
                } else {
                    _img.width = 180;
                    var _result = (180 / _imgWidth) * _imgHeight;
                    _img.height = _result;

                    console.log(_img.width);
                    console.log(_img.height);
                    //$(obj).css("width","161");
                    //$(obj).css("height",161/_imgWidth*_imgHeight);
                }
            }
            var height = _img.height / 2;
            var width = _img.width / 2;

            _img.style.marginTop = -height + 'px';
            _img.style.marginLeft = -width + 'px';
            // $(obj).css("margin-top",-height);
            //$(obj).css("margin-left",-width);
        },
    },
};
</script>

<style scoped lang="less">
.mt8 {
    margin-top: 8px;
}

.conditionclass {
    img {
        height: 80px;
    }
    th {
        margin-bottom: 0px;
    }
}
.card-list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .card-item {
        width: 230px;
        background-color: #ffffff;
        margin: 5px;
        cursor: pointer;
        color: #444;
        .image {
            padding: 16px 65px;
            position: relative;
            height: 182px;
            img {
                position: absolute;
                top: 50%;
                left: 50%;
            }
        }
        .info {
            border-top: 1px solid #f2f2f2;
            padding: 12px;
            .product-name {
                font-size: 14px;
                color: #444;
                line-height: 24px;
                word-break: break-all;
            }
            .product-extra {
                display: flex;
                flex-wrap: wrap;
                p {
                    width: 50%;
                    margin: 0;
                    font-size: 10px;
                    line-height: 20px;
                    .label {
                        color: #999;
                    }
                    .active {
                        color: #3c9539;
                    }
                }
            }
        }
    }
}
// .list {
//     background-color: #fff;
//     position: relative;
//     table {
//         position: relative;
//         z-index: 1;
//         .th {
//             background: transparent;
//         }
//     }
// }
.add-cart {
    width: 88px;
    margin: 0 8px;
    line-height: 32px;
    background-color: #ff9236;
    border-radius: 20px;
    display: inline-block;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
}
// .list::after {
//     content: '';
//     width: 100%;
//     height: 52px;
//     background-image: linear-gradient(90deg, #6db231 0%, #37923a 100%);
//     position: absolute;
//     top: 0;
//     left: 0;
// }
</style>
